import { PHMS_CASE_CONTEXT_TERMINOLOGY } from "../../phms-case-context.terminology";
import { PHMS_FACILITY_TERMINOLOGY } from "../../phms-facility.terminology";
import { TERMINOLOGY_TOKENS } from "@app/shared/terminology/terminology-token.catalog";
import { defineTerminologyUsage, TerminologyUsageDeclaration, TERMINOLOGY_CONFIGURATION_CODES, TERMINOLOGY_USAGE_KINDS } from "@app/shared/terminology/terminology-usage";

const surface = {
  featureCode: "phms", surfaceCode: "pre-hearing-case-review",
  componentCode: "PreHearingCaseReviewSectionComponent",
  locations: [{ kind: "route" as const, value: "/phms/hearing-detail" }],
};
const reuse = (name: string, source: TerminologyUsageDeclaration) => defineTerminologyUsage({
  ...source, usageId: `phms.pre-hearing.case-review.${name}`, surface,
});
const column = (name: string, token: typeof TERMINOLOGY_TOKENS[keyof typeof TERMINOLOGY_TOKENS], fallbackText: string) => defineTerminologyUsage({
  usageId: `phms.pre-hearing.case-review.${name}`, token, fallbackText, surface,
  configurationCode: TERMINOLOGY_CONFIGURATION_CODES.programPack, kind: TERMINOLOGY_USAGE_KINDS.gridHeader,
});

/** Reuse vocabulary tokens, with distinct identities for the hearing review occurrences. */
export const PRE_HEARING_CASE_REVIEW_TERMINOLOGY = {
  hearingHistory: reuse("hearing-history", PHMS_CASE_CONTEXT_TERMINOLOGY.hearingHistory.heading),
  violations: reuse("violations", PHMS_CASE_CONTEXT_TERMINOLOGY.violations.heading),
  programming: reuse("programming", PHMS_CASE_CONTEXT_TERMINOLOGY.programming.heading),
  behaviorSummary: reuse("behavior-summary", PHMS_FACILITY_TERMINOLOGY.preHearing.behaviorSummary),
  hearingDate: column("hearing-date", TERMINOLOGY_TOKENS.hearingDate, "Hearing Date"),
  hearingType: column("hearing-type", TERMINOLOGY_TOKENS.hearingType, "Hearing Type"),
  hearingPanel: column("hearing-panel", TERMINOLOGY_TOKENS.hearingPanel, "Hearing Panel"),
  outcome: column("outcome", TERMINOLOGY_TOKENS.decisionOutcome, "Outcome"),
  status: column("status", TERMINOLOGY_TOKENS.operationalStatus, "Status"),
} as const;
